<div class="dashboard">
  <div class="dashboard-header">
    <div class="header-content">
      <h2>Conversation Detail Overview</h2>
      <button mat-stroked-button color="accent" (click)="downloadCSV()">
        <mat-icon>download</mat-icon> CSV
      </button>
    </div>
  </div>

  <div class="filters">
    <mat-form-field appearance="outline">
      <mat-label>Start Date</mat-label>
      <input matInput [matDatepicker]="sp" [(ngModel)]="startDate">
      <mat-datepicker-toggle matSuffix [for]="sp"></mat-datepicker-toggle>
      <mat-datepicker #sp></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>End Date</mat-label>
      <input matInput [matDatepicker]="ep" [(ngModel)]="endDate">
      <mat-datepicker-toggle matSuffix [for]="ep"></mat-datepicker-toggle>
      <mat-datepicker #ep></mat-datepicker>
    </mat-form-field>

    <button mat-raised-button color="primary" (click)="fetchDetails()">Update</button>
  </div>

  <mat-form-field appearance="outline" style="width: 100%; margin-top: 1rem;">
    <mat-label>Search conversations or categories...</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Billing" #input>
  </mat-form-field>

  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort class="styled-table">

      <ng-container matColumnDef="conversation_id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
        <td mat-cell *matCellDef="let row"> <code>{{row.conversation_id}}</code> </td>
      </ng-container>

      <ng-container matColumnDef="category">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Category </th>
        <td mat-cell *matCellDef="let row"> {{row.category}} </td>
      </ng-container>

      <ng-container matColumnDef="satisfied">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Satisfied </th>
        <td mat-cell *matCellDef="let row" style="color: green;"> {{row.satisfied_count}} </td>
      </ng-container>

      <ng-container matColumnDef="not_satisfied">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Not Satisfied </th>
        <td mat-cell *matCellDef="let row" style="color: red;"> {{row.not_satisfied_count}} </td>
      </ng-container>

      <ng-container matColumnDef="total">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Total </th>
        <td mat-cell *matCellDef="let row"> {{row.total_interactions}} </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> Action </th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button color="primary" matTooltip="View Details">
            <mat-icon>visibility</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
  </div>
</div>